import { LANGUAGES } from '../services/translation/i18n';

export const normalizeLocale = (locale?: string): string => {
  if (!locale) return 'en-US'; // fallback default

  const lower = locale.toLowerCase();

  // exact match first
  const exact = LANGUAGES.find((language) => language.toLowerCase() === lower);
  if (exact) return exact;

  // match by base language
  const base = lower.split('-')[0];

  const match = LANGUAGES.find((language) => language.toLowerCase().startsWith(base));

  return match || 'en-US'; // fallback is supported
};
